import type { CSSProperties, ReactNode } from 'react';
import { dataEl, type DataElScope } from '@/utils/dataEl';
interface CstretchmodalFloatingFooterProps {
    dataElScope: DataElScope;
    floatingFooter: boolean;
    footer: ReactNode;
    style: CSSProperties;
}
export function CstretchmodalFloatingFooter({ dataElScope, floatingFooter, footer, style, }: CstretchmodalFloatingFooterProps): ReactNode {
    if (!footer) {
        return footer;
    }
    if (!floatingFooter) {
        return false;
    }
    return (
      <div data-el={dataEl(dataElScope, 'FloatingFooter/Root')} style={style}>
        {footer}
      </div>
    );
}
